<template>
  <div class="min-h-screen bg-gray-50">
    <template v-if="!route.meta.hideLayout">
    <Header />
    <main class="min-h-screen bg-gray-50" style="padding-top: var(--header-height)">
      <RouterView />
    </main>
    <Footer />
    </template>
    <template v-else>
      <RouterView />
    </template>
    <ContactModal />
  </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import ContactModal from '@/components/layout/ContactModal.vue'

const route = useRoute()
</script>

